// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__L5CIg","paramInput":"JobSimulator_paramInput__2jnFy","input":"JobSimulator_input__2AG7F"};